export interface IReportsTitleBarState {
  companies: any[];
  items: any[];
  warehouseLocations: any[];
  isLoading: boolean;
  error: string;
  isError: boolean;
  assemblyItems: any[];
  bomData: any[

  ]
}

export const state: IReportsTitleBarState = {
  companies: [],
  items: [],
  warehouseLocations: [],
  isLoading: true,
  assemblyItems: [],
  bomData: [],
  error: "",
  isError: false,
};

export default state;
